import AppRouter from "navigation/AppRouter";
import { useRecoilValue } from "recoil";
import { darkModeState } from "atoms/theme";

const App = () => {
  const darkMode = useRecoilValue(darkModeState);

  return (
    <div className={`flex flex-col min-h-screen ${darkMode ? "dark" : ""}`}>
      <section className="flex flex-grow flex-shrink bg-gradient-to-bl from-ghPurple to-ghBlue dark:from-gray-700 dark:to-gray-400">
        <AppRouter />
      </section>
    </div>
  );
};

export default App;
